import { render, staticRenderFns } from "./LargeSpinner.vue?vue&type=template&id=12815eb4&scoped=true&lang=pug&"
import script from "./LargeSpinner.vue?vue&type=script&lang=js&"
export * from "./LargeSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LargeSpinner.vue?vue&type=style&index=0&id=12815eb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12815eb4",
  null
  
)

export default component.exports